import { FormattedMessage } from "react-intl";

import { Text } from "@/components/atoms/Text";
import { useListingData } from "~/context/ListingPageDataContext";

import { ReadMoreText } from "../../utils/ReadMoreToggle";

import { FsvDetailsSection } from "./full-service-venues/components/FsvDetailsSection";

export const AboutTheSpace = () => {
  const { data: listingData } = useListingData();
  const { fullService, listingId, listingVenueName, description } =
    listingData || {};

  return (
    <div id="about_section">
      <div>
        <Text
          element="h2"
          typeface="headline-2-m"
          className="lg:tw-mt-24 tw-mt-12 tw-mb-12"
          data-testing-id="aboutTheSpaceSectionTitle"
        >
          {listingVenueName ? (
            <FormattedMessage
              defaultMessage="About {listingVenueName}"
              values={{
                listingVenueName,
              }}
            />
          ) : (
            <FormattedMessage defaultMessage="About the Space" />
          )}
        </Text>
        <ReadMoreText
          text={description}
          readMoreButtonDataTestingId="readMoreDescriptionButton"
          hideButtonDataTestingId="hideDescriptionButton"
          analyticEvent={() => {
            window.analyticsIntegrations.trackEvent(
              "listing description expanded",
              {
                listingId: listingId,
              },
            );
          }}
        />
      </div>

      {fullService?.active && (
        <div className="tw-my-24">
          <FsvDetailsSection />
        </div>
      )}
    </div>
  );
};
